/* eslint-disable react-hooks/rules-of-hooks */
import { FeatureFlag } from 'src/utils/feature-flags'
import { useRecoilValueLoadable } from 'recoil'

import * as atoms from 'src/atoms/admin'

export const isFeatureEnabled = (key: FeatureFlag) => {
  const valueLoadable = useRecoilValueLoadable(atoms.featureEnabled(key))
  if (valueLoadable.state === 'hasValue') {
    return valueLoadable.contents
  }
  return false
}

export const isFeatureEnabledNullable = (key: FeatureFlag) => {
  const valueLoadable = useRecoilValueLoadable(atoms.featureEnabled(key))
  if (valueLoadable.state === 'hasValue') {
    return valueLoadable.contents
  }
  return null
}

export const nFeaturesEnabled = (keys: FeatureFlag[]) => {
  let count = 0
  for (const key of keys) {
    if (isFeatureEnabled(key)) {
      count += 1
    }
  }
  return count
}
